import { useContext, useEffect, useMemo, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import { Button } from "../../../../../stories/Button/Button";
import Input from "../../../../../stories/Input/Input";

import {
  CustomModal,
  getModifiedScrollHeight,
} from "../../../../../utils/UtilFunctions";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import Assign from "../../../../../images/Assign.svg";
import Edit from "../../../../../images/EditProfile.svg";

import { TableHeaderProps } from "../../../../../utils/types";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import OBDetails from "./OBDetails";
import { CustomModalStyles } from "../../../../../styles/CustomModalStyles";
import { useNavigate } from "react-router-dom";
import {
  AtsStckCompanyItemLdgrEdge,
  AtsStckCompanyItemLdgrOrderField,
  GetStockCompanyItemLdgrResult,
  GetStockCompanyItemLdgrVar,
  ItemQueryType,
} from "../../masters/items/queries/types";
import { useLazyQuery } from "@apollo/client";
import { FETCH_MORE_DATA, ROWS_PER_PAGE, debouncedDelay } from "../../../../../utils/constants";
import { NavTypeProps } from "../ItemsList";
import Navbar from "../../../../common/layout/Navbar";
import useToken from "../../../../../customHooks/useToken";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import ItemGroupSelect from "../../../../../customComponents/ItemGroupSelect";
import { AppContext } from "../../../../../context/context";
import { responseType } from "../../../../../utils/formTypes";
import ItemCategorySelect from "../../../../../customComponents/ItemCategorySelect";
import ItemManufacturerSelect from "../../../../../customComponents/ItemManufacturerSelect";
import { payloadTypes } from "../../../../../context/reducer";
import { GetStockCompanyItemLdgr } from "../../masters/items/queries/queries";
import { useHotKey } from "../../../../../utils/hotKeys";
import { SpecialKeys } from "../../../../../utils/Enum.keys";
import useLabels from "../../../../../customHooks/useLabels";
import { useDebounce } from "../../../../../customHooks/useDebounce";

const ItemOBList = ({ NavType }: NavTypeProps) => {
  const { Items } = useAssetTableJson();
  const [addModal, setAddModal] = useState(false);
  const navigate = useNavigate();

  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [items, setItems] = useState<AtsStckCompanyItemLdgrEdge[]>([]);
  const [selectedGroup, setSelectedGroup] = useState<responseType | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<responseType | null>(
    null
  );

  const [selectedManufacturer, setSelectedManufacturer] =
    useState<responseType | null>(null);

  const [hsnCode, setHSNCode] = useState<string>("");

  // const [selectedSubCategory, setSelectedSubCategory] =
  //   useState<responseType | null>(null);

  const [searchData, setSearchData] = useState("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);

  const { customer_id, company_id } = useUrlParams();

  const { handleToken } = useToken();

  const { state, dispatch } = useContext(AppContext);

  const [GetItem, { data, loading, fetchMore }] = useLazyQuery<
    GetStockCompanyItemLdgrResult,
    GetStockCompanyItemLdgrVar
  >(GetStockCompanyItemLdgr);

  const dynamicHeaders: TableHeaderProps[] = Items.List.filter(
    (header) => header.field !== "total_asset"
  ).map((header) => ({
    headerName: header.headerName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
    cellClassName: header.cellClassName,
    renderCell: (params) => {
      if (header.field === "actions") {
        return (
          <>
            {params.row.ob === 0 ? (
              <button
                className="item-ob__tableblock--assign"
                onClick={() => {
                  dispatch({
                    type: payloadTypes.SET_ITEM_LEDGER_ID,
                    payload: {
                      itemLedgerId: params.row.item_ldgr_id,
                    },
                  });
                  setAddModal(!addModal);
                }}
              >
                Enter OB <img src={Assign} alt="" />
              </button>
            ) : (
              <button
                className="item-ob__tableblock--update"
                onClick={() => {
                  dispatch({
                    type: payloadTypes.SET_ITEM_LEDGER_ID,
                    payload: {
                      itemLedgerId: params.row.item_ldgr_id,
                    },
                  });
                  setAddModal(!addModal);
                }}
              >
                Update OB <img src={Edit} alt="" />
              </button>
            )}
          </>
        );
      }

      return params.value;
    },
  }));
  const columns: GridColDef[] = [...dynamicHeaders];

  const rows: GridValidRowModel[] = useMemo(() => {
    return items.map(({ node: data }, index) => {
      return {
        id: index + 1,
        code: data.item.code,
        description: data.item.desc,
        group: data.item.groupDetails.groupName,
        category: data.item.categoryDetails.categoryName,
        sub_catg: "",
        model: "",
        uom: data.item.uom,
        ob: data.stkOb,
        item_ldgr_id: data.id,
      };
    });
  }, [items]);

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(ColumnVisibilityFor.ITEMS_OB);
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.ITEMS_OB,
      JSON.stringify(newModel)
    );
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetStockCompanyItemLdgr.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = items.find(
            (sub) => sub.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setItems(updatedNewData);
      } else {
        setItems(newData);
      }
      setEndCursor(data.GetStockCompanyItemLdgr.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetStockCompanyItemLdgr.edges;
              const pageInfo = fetchMoreResult.GetStockCompanyItemLdgr.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck =
                prevResult.GetStockCompanyItemLdgr.edges.filter(
                  ({ node: { id } }) =>
                    newEdges.findIndex(
                      ({ node: { id: newId } }) => newId === id
                    ) !== -1
                );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetStockCompanyItemLdgr: {
                  edges: [...items, ...newEdges],
                  pageInfo,
                  totalCount: data
                    ? data.GetStockCompanyItemLdgr.totalCount!
                    : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable) scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = await handleToken();
        if (token && customer_id && company_id) {
          GetItem({
            variables: {
              after: null,
              customerID: customer_id,
              companyID: company_id,
              input: {
                query_type: ItemQueryType.All,
                stckCategoryID: selectedCategory ? selectedCategory.value : 0,
                stckGroupID: selectedGroup ? selectedGroup.value : 0,
                stckManufacturerID: selectedManufacturer
                  ? selectedManufacturer.value
                  : 0,
                stckUomID: 0,
                stckSubCategoryID: 0,
                ldgrID: 0,
                subsidiaryID: 0,
                isComponent: undefined,
              },
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsStckCompanyItemLdgrOrderField.CREATED_AT,
              },
              token,
              name: debouncedSearch,
              hsnCode,
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [
    customer_id,
    GetItem,
    debouncedSearch,
    selectedCategory,
    selectedGroup,
    selectedManufacturer,
    hsnCode,
  ]);

  //hot key for addition ctrl+a
  useHotKey({
    handleFunc: () => {
      setAddModal(!addModal);
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });
  const { itemLabel } = useLabels();
  return (
    <>
      <Navbar NavType={NavType} />
      <Title>{itemLabel} - OB</Title>
      <div className="item-ob">
        <div className="item-ob__select row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e) => setSearchData(e.target.value)}
            />
          </div>
          <div className="col">
            <ItemGroupSelect
              label="Group"
              onChange={(newValue) => {
                if (newValue) {
                  setSelectedGroup(newValue);
                } else {
                  setSelectedGroup(null);
                }
              }}
              onKeyDown={() => {}}
              value={selectedGroup ? selectedGroup.value : 0}
            />
          </div>
          <div className="col">
            <ItemCategorySelect
              label="Category"
              onChange={(newValue) => {
                if (newValue) {
                  setSelectedCategory(newValue);
                } else {
                  setSelectedCategory(null);
                }
              }}
              onKeyDown={() => {}}
              value={selectedCategory ? selectedCategory.value : 0}
            />
          </div>
          {/* <div className="col">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Sub Category"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div> */}
          <div className="col">
            <ItemManufacturerSelect
              label="Manufacturer"
              onChange={(newValue) => {
                if (newValue) {
                  setSelectedManufacturer(newValue);
                } else {
                  setSelectedManufacturer(null);
                }
              }}
              onKeyDown={() => {}}
              value={selectedManufacturer ? selectedManufacturer.value : 0}
            />
          </div>
          <div className="col">
            <Input
              id="data_search"
              placeholder="HSN Code"
              onChange={(e) => setHSNCode(e.target.value)}
            />
          </div>
        </div>
        <div className="item-ob__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            initialState={{
              columns: {
                columnVisibilityModel: columnVisibilityModel,
              },
            }}
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
        <Button mode="export" />
        <Button mode="back" onClick={() => navigate(-1)} />
      </div>

      <CustomModal
        isOpen={addModal}
        onRequestClose={() => setAddModal(!addModal)}
        contentComponent={<OBDetails setModalFlag={setAddModal} />}
        style={CustomModalStyles}
      />
    </>
  );
};

export default ItemOBList;
